// Counter-rotates image bytes by the given number of clockwise 90deg steps.
// Always re-encodes to PNG.
export async function rotateImageBytes(data: ArrayBuffer, clockwiseSteps: number): Promise<ArrayBuffer> {
  const steps = ((clockwiseSteps % 4) + 4) % 4;
  if (steps === 0) {
    return data;
  }

  const bitmap = await createImageBitmap(new Blob([data]));
  const swapDimensions = steps % 2 === 1;
  const canvas = document.createElement("canvas");
  canvas.width = swapDimensions ? bitmap.height : bitmap.width;
  canvas.height = swapDimensions ? bitmap.width : bitmap.height;

  const context = canvas.getContext("2d")!;
  context.translate(canvas.width / 2, canvas.height / 2);
  context.rotate((-steps * 90 * Math.PI) / 180);
  context.drawImage(bitmap, -bitmap.width / 2, -bitmap.height / 2);
  bitmap.close();

  const blob: Blob = await new Promise((resolve, reject) => {
    canvas.toBlob(result => (result ? resolve(result) : reject(new Error("canvas.toBlob failed"))), "image/png");
  });
  return blob.arrayBuffer();
}
